import React, { useEffect, useRef, useState } from "react";
import { useIds } from "../../../../hook/AdminContext";
import { FacebookIcon } from "../../../../assets/icon/FacebookIcon";
import InstagramIcon from "../../../../assets/icon/InstagramIcon";
import TiktokIcon from "../../../../assets/icon/TiktokIcon";
import LinkedinIcon from "../../../../assets/icon/LinkedinIcon";
import YoutubeIcon from "../../../../assets/icon/YoutubeIcon";
import { Divider } from "@mui/material";
import { TwitterIcon } from "../../../../assets/icon/TwitterIcon";
import JobSwiper from "../../../../components/CustomSwiper/JobSwiper";
import AchievementListing from "../Media/MediaListing";
import PostSwiper from "../../../../components/CustomSwiper/PostSwiper";
import { s3baseUri } from "../../../../config/config";
import { double_arrow_icon } from "../../../../assets";
import RecordNoImage from "../../../../components/recordNotFound/RecordNoImage";
import CreatePost from "../../../post/CreatePost";

function Home({ data, handleMoveToMedia, fetchDetails }) {
  const [customWidth, setCustomWidth] = React.useState(0);
  const { userInfo, handleEmailClick } = useIds();

  // edit feed states
  const [formAction, setFormAction] = useState("EDIT");
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [previewLink, setPreviewLink] = useState(true);
  const [feedType, setFeedType] = useState("");

  console.log(data, "--data");

  const handleFeedEdit = (selected_feed) => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenCreateModal(true);
      return;
    }

    setFormAction("EDIT");
    setSelectedFeed(selected_feed);
    setOpenCreateModal(true);
  };

  useEffect(() => {
    document.getElementsByClassName("client-info")[0]?.offsetWidth &&
      setCustomWidth(
        document.getElementsByClassName("client-info")[0]?.offsetWidth - 50
      );
  }, []);

  if (
    (data.feeds || []).length === 0 &&
    (data.achievements || []).length === 0 &&
    (data.media || []).length === 0
  ) {
    return (
      <div className="text-center">
        <RecordNoImage title={`No data found.`} />
      </div>
    );
  }
  return (
    <>
      {((userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          (userInfo?.company_access?.feed?.add ||
            userInfo?.company_access?.feed?.update))) && (
        <>
          {openCreateModal && (
            <CreatePost
              setFeedType={setFeedType}
              feedType={feedType}
              openCreateModal={openCreateModal}
              setOpenCreateModal={setOpenCreateModal}
              userInfo={userInfo}
              getFeedsListing={() => {
                fetchDetails();
              }}
              selectedFeed={selectedFeed}
              type={formAction}
              setFormAction={setFormAction}
              previewLink={previewLink}
              setPreviewLink={setPreviewLink}
            />
          )}
        </>
      )}

      {/* ABOUT / DESCRIPTION */}
      {data.feeds?.length > 0 && (
        <div className="">
          <PostSwiper
            data={data.feeds}
            getFeedsListingOnDelete={fetchDetails}
            handleFeedEdit={handleFeedEdit}
          ></PostSwiper>
        </div>
      )}

      {/* Achievements */}
      {(data.achievements || []).length > 0 && (
        <>
          <div className="mt-4 d-flex justify-content-between align-items-center">
            <h4>Recent Achievements</h4>
            <div
              className="hover-primary"
              onClick={() => handleMoveToMedia("achievements")}
            >
              <span>view all</span> <img src={double_arrow_icon} alt="" />
            </div>
          </div>

          {(data.achievements || []).length > 0 ? (
            <div className="media-grid">
              {data.achievements.slice(0, 4).map((item) => (
                <div className={item ? "media-grid-item" : "d-none"}>
                  <img
                    src={s3baseUri + item.assets.thumbnail_4}
                    alt={item.title}
                    className="img-fluid"
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center">
              <RecordNoImage title={`No achievements found.`} />
            </div>
          )}
        </>
      )}
      {/* Media */}
      {(data.media || []).length > 0 && (
        <>
          <div className="mt-4 d-flex justify-content-between align-items-center">
            <h4>Recent Media</h4>
            <div
              className="hover-primary"
              onClick={() => handleMoveToMedia("media")}
            >
              <span>view all</span> <img src={double_arrow_icon} alt="" />
            </div>
          </div>
          {(data.media || []).length > 0 ? (
            <div className="media-grid">
              {data.media.slice(0, 4).map((item) => (
                <div className={item ? "media-grid-item" : "d-none"}>
                  <img
                    src={s3baseUri + item.assets.thumbnail_4}
                    alt={item.title}
                    className="img-fluid"
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center">
              <RecordNoImage title={`No media found.`} />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default Home;
